module.exports = "<div class=\"wrapper\">\n  <ng-content></ng-content>\n  <div class=\"ui_validation_balloon rt\" [hidden]=\"!(control.errors && (control.dirty || control.touched))\">\n    <div class=\"ui_validation_balloon_body\">\n      <i class=\"ico error mr10 mb-2\"></i>\n      {{errorMessage}}\n    </div>\n    <div class=\"ui_validation_balloon_point\">\n      <div></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/validation-balloon/validation-balloon.component.html
// module id = pdsq
// module chunks = 6